import { useState, useRef } from "react";
import { URL_CONSTANTS } from "../../axios/urlLinksThemes";
import { httpGet, httpPostWithAuth } from "../../axios/axiosUtils";
import {
  getBussinessData,
  showErrortMessage,
} from "../../shared/helpersMethod";
import { IRESAllData } from "../../shared/commonUtils";
import useGetToken from "../useGetToken";

const usePlaceOrder = () => {
  const [loading, setLoading] = useState(false);
  const [placeOrderError, setPlaceOrderError] = useState<boolean>(false);
  const [placeOrderMessage, setPlaceOrderMessage] = useState<string>("");
  const { getToken } = useGetToken();

  // Prevent multiple simultaneous API calls
  const apiCallInProgress = useRef(false);

  const placeOrderApi = async (
    orderData: any,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return { placeOrderData: {}, paymentLink: "" };
    }

    let businessData = getBussinessData();
    if (!businessData?.accessToken) {
      try {
        await getToken();
        businessData = getBussinessData();
        if (!businessData?.accessToken) {
          return { placeOrderData: {}, paymentLink: "" };
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return { placeOrderData: {}, paymentLink: "" };
      }
    }

    var successPlaces = false;
    var paymentLink = "";
    var placeOrderData = {};

    apiCallInProgress.current = true;
    setLoading(true);

    try {
      const res: IRESAllData = await httpPostWithAuth(
        URL_CONSTANTS.get("URL_PLACE_ORDER")!,
        { ...orderData },
        businessData.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return placeOrderApi(orderData, true);
        }
        return { placeOrderData: {}, paymentLink: "" };
      }

      if (res?.data?.message === "Order is placed successfully") {
        placeOrderData = res?.data;
      }
      if (res?.data?.message === "Get payment Link successfully") {
        placeOrderData = res?.data;
        paymentLink = res?.data?.payment_link;
      }
      if (res.type === "error") {
        setPlaceOrderError(true);
        setPlaceOrderMessage(res.message);
        if (res.data && res.data?.aqsati_error) {
          setPlaceOrderMessage(res.data?.aqsati_error);
        }
      }

      return { placeOrderData, paymentLink };
    } catch (error: any) {
      console.log(error.message);
      setPlaceOrderError(true);
      setPlaceOrderMessage("Something went wrong");
      return { placeOrderData: {}, paymentLink: "" };
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  const abandonedCartApi = async (
    orderData: any,
    sessionId,
    retryAfterTokenRefresh = false
  ) => {
    // Prevent multiple simultaneous calls (but allow retry after token refresh)
    if (apiCallInProgress.current && !retryAfterTokenRefresh) {
      return { placeOrderData: {}, paymentLink: "" };
    }

    let businessData = getBussinessData();
    if (!businessData?.accessToken) {
      try {
        await getToken();
        businessData = getBussinessData();
        if (!businessData?.accessToken) {
          return { placeOrderData: {}, paymentLink: "" };
        }
      } catch (error) {
        console.error("Failed to get token:", error);
        return { placeOrderData: {}, paymentLink: "" };
      }
    }

    var successPlaces = false;
    var paymentLink = "";
    var placeOrderData = {};

    apiCallInProgress.current = true;
    setLoading(true);

    try {
      const res: IRESAllData = await httpPostWithAuth(
        URL_CONSTANTS.get("URL_Abandoned_ORDER")!,
        { ...orderData, sessionid: sessionId },
        businessData.accessToken
      );

      if (res.type === "error" && res?.token === "expired") {
        apiCallInProgress.current = false;
        const newToken = await getToken(true);
        if (newToken) {
          return abandonedCartApi(orderData, sessionId, true);
        }
        return { placeOrderData: {}, paymentLink: "" };
      }

      if (res?.data?.type === "success") {
        placeOrderData = res?.data;
      }
      // if (res?.data?.message === "Get payment Link successfully") {
      //   placeOrderData = res?.data;
      //   paymentLink = res?.data?.payment_link;
      // }
      if (res.type === "error") {
        setPlaceOrderError(true);
        setPlaceOrderMessage(res.message);
        // if (res.data && res.data?.aqsati_error) {
        //   setPlaceOrderMessage(res.data?.aqsati_error);
        // }
      }
      return { placeOrderData, paymentLink };
    } catch (error: any) {
      console.log(error.message);
      setPlaceOrderError(true);
      setPlaceOrderMessage("Something went wrong");
      return { placeOrderData: {}, paymentLink: "" };
    } finally {
      setLoading(false);
      apiCallInProgress.current = false;
    }
  };

  return {
    abandonedCartApi,
    placeOrderApi,
    placeOrderError,
    setPlaceOrderError,
    placeOrderMessage,
    loading,
  };
};

export default usePlaceOrder;
